import styled from 'styled-components';

import { SkeletonContainer } from 'ui/skeleton';
import { Body2, colors, borderRadius } from 'ui/theme';
import { pxToRem } from 'utils/convert';

const RADIUS = borderRadius.md;
const BG = colors.backgroundDisabled;
const ACTIVE_BG = colors.purple50;
const COLOR = colors.textDisabled;
const ACTIVE_COLOR = colors.textOnColor;

export const Wrapper = styled(SkeletonContainer)`
  display: inline-flex;
  align-items: flex-start;
  gap: ${pxToRem(1)};
  position: relative;
  ${({ isLoading }) => isLoading && `border-radius: ${RADIUS};`}
`;

export const Result = styled.div<{ $active: boolean }>`
  display: flex;
  width: ${pxToRem(44)};
  height: ${pxToRem(40)};
  justify-content: center;
  align-items: center;
  gap: ${pxToRem(8)};
  padding: ${pxToRem(8)};
  ${({ $active }) => `background: ${$active ? ACTIVE_BG : BG};`}

  &:first-child {
    border-radius: ${RADIUS} 0 0 ${RADIUS};
  }

  &:last-child {
    border-radius: 0 ${RADIUS} ${RADIUS} 0;
  }

  ${Body2} {
    ${({ $active }) => `color: ${$active ? ACTIVE_COLOR : COLOR};`}
  }
`;
